document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('.pj-global-menu-button');
  const mobileMenu = document.getElementById('PJGlobalMobileMenu');
  const closeMenu = () => {
    if (!menuButton || !mobileMenu) return;
    menuButton.setAttribute('aria-expanded', 'false');
    menuButton.setAttribute('aria-label', 'Open menu');
    mobileMenu.hidden = true;
  };

  if (menuButton && mobileMenu) {
    menuButton.addEventListener('click', () => {
      const isOpen = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!isOpen));
      menuButton.setAttribute('aria-label', isOpen ? 'Open menu' : 'Close menu');
      mobileMenu.hidden = isOpen;
    });
    mobileMenu.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeMenu();
    });
  }

  const query = new URLSearchParams(window.location.search);
  const productField = document.querySelector('[data-pj-rental-product]');
  if (productField && query.get('product')) productField.value = query.get('product');

  document.querySelectorAll('[data-pj-rental-link]').forEach((link) => {
    link.addEventListener('click', () => {
      try {
        sessionStorage.setItem('pjRentalProduct', link.dataset.product || document.title);
      } catch (error) {}
    });
  });

  if (productField && !productField.value) {
    try { productField.value = sessionStorage.getItem('pjRentalProduct') || ''; } catch (error) {}
  }
});
